import { Link, useNavigate } from 'react-router-dom'
import { SvgIcon, SvgType } from '../../../common/svgIcon/SvgIcon'
import routes from '../../../routes'
import { LiveSessionType } from '../../../slices/sessionSlice'
import { OnDemandCardStyle } from './styled'

const OnDemandCard = ({
  liveSession,
  setSpeakers,
}: {
  liveSession: LiveSessionType
  setSpeakers: any
  ended?: boolean
}) => {
  const navigate = useNavigate()

  const handleJoin = (e: any) => {
    e.preventDefault()
    navigate(`${routes.onDemandSessions}/${liveSession.id}`)
  }

  return (
    <OnDemandCardStyle>
      {liveSession.hasAccess || (
        <div className="lockOverlay">
          <div className="lock">
            <SvgIcon type={SvgType.LOCK} />
            <div>Premium</div>
          </div>
        </div>
      )}

      {liveSession.onDemandThumbnail || liveSession.thumbnail ? (
        <img
          className="sessionThumbnail"
          src={liveSession.onDemandThumbnail || liveSession.thumbnail}
          alt={liveSession.title}
          width={'100%'}
        />
      ) : (
        <div className="cardPlaceholder"></div>
      )}

      <div className="overlay">
        {/* <button className="btn btn-outline-info">View Speaker</button> */}
        {liveSession.presenters.length ? (
          <button
            className="btn btn-outline-warning"
            onClick={() => {
              setSpeakers(liveSession.presenters)
            }}
          >
            VIEW SPEAKER
          </button>
        ) : null}
        <Link
          to={`${liveSession.id}`}
          className={`btn btn-outline-danger`}
          onClick={handleJoin}
        >
          {'WATCH NOW'}
        </Link>
      </div>
    </OnDemandCardStyle>
  )
}

export default OnDemandCard
